<div class=" row mt-3 " style="padding: 10px;">
                         
                          
    <div class="col-md-12 " >
      <div class=" col-md-12 row">
      <mat-form-field class=" col-md-3 mt-1 form-group " >
      <input matInput type="text"     placeholder="Search..." [(ngModel)]="searchText" (input)="searchFilter()" autocomplete="off"   >
      
      </mat-form-field>
      <div class="col-md-1 mt-3 ">
     <div class="col-md-12 d-flex justify-content-end">
        <button  class="btn btn-outline-primary btn-sm " (click)="onAddAirport()">
            <img src="assets/images/Add_24.png"></button>
    </div>
      </div>
      <mat-paginator  class="col-md-8 mt-2 " style="background-color: transparent;" color="primary"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 25, 100]"
      [length]="totalElements"
      (page)="nextPage($event)"
      aria-label="Select page">
      </mat-paginator>
      
      </div>
      <div class="col-md-12" style="overflow: auto ;max-height:50vh;">
      <table mat-table 
      [dataSource]="airportData" multiTemplateDataRows style="background-color: transparent;">
     
     
       <ng-container matColumnDef="name">
         <th mat-header-cell *matHeaderCellDef> Name</th>
         <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" (click)="rowAirportClick(element)"> {{element.name}} </td>
       </ng-container>
      <ng-container matColumnDef="iataCode">
       <th mat-header-cell *matHeaderCellDef>Iata Code </th>
       <td mat-cell *matCellDef="let element"> 
          {{element.iataCode||''}}
         </td>
      </ng-container>
      
     
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef>City</th>
        <td mat-cell *matCellDef="let element"> {{element?.city}} </td>
       </ng-container>
       <ng-container  matColumnDef="state">
        <th mat-header-cell *matHeaderCellDef>State</th>
        <td mat-cell *matCellDef="let element">
          {{element?.state}}
           <!-- <button style="background-color: #3389fa;color: white;margin: 4px; " mat-flat-button >GST Detail</button> -->
        </td>
       </ng-container>
       <ng-container matColumnDef="country">
        <th mat-header-cell *matHeaderCellDef>Country</th>
        <td mat-cell *matCellDef="let element"> {{element?.country}} </td>
       </ng-container>
      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container  matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="columnsAirportsDisplay.length">
      <div class="example-element-detail row"
       [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
      
      </div>
      </td>
      </ng-container>
      
      <tr mat-header-row *matHeaderRowDef="columnsAirportsDisplay;sticky" style="background-color: white;"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsAirportsDisplay;"
      class="example-element-row">
      </tr>
      <tr  mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
      <tr class="mat-row" *matNoDataRow>
      <td  class="mat-cell" colspan="4">There is no data in this table</td>
      </tr>
      </table>
      
    </div>
      </div>
      
  

</div> 

<div class="modal "  id="myMod"  [style.display]="showAirportPopup ? 'block' : 'none'" >
    <div class="modal-dialog" >
        <div class="modal-content " >
            <div class="modal-header title" *ngIf="showAirportPopup">
              <h4 *ngIf="action==='new'"  class="modal-title">Add Airport</h4>
              <h4 *ngIf="action==='update'"  class="modal-title">Edit Airport</h4>


            <!-- <button *ngIf="!selectedFile && action==='new'" type="button" mat-raised-button (click)="fileInput.click()">Select File</button>
            <button *ngIf="selectedFile && action==='new'" type="button" mat-raised-button (click)="fileInput.click()">{{selectedFile?.name}}</button>

            <input    hidden  accept=".xlsx, .xls" (change)="onFileSelected($event)" #fileInput type="file"> 
            <button *ngIf="action==='new'"  class="btn btn-outline-success c-width-100px shadow " (click)="uploadFile()"  [disabled]="!fileSelected">Bulk Upload</button> -->





              <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
              </div>
              <div class="modal-body">
              <div class="col-md-12 mt-3 " *ngIf="showAirportPopup">
                <div class="col-md-12 d-flex justify-content-center" >
                <div class="col-md-12 row " >
                    <div class=" col-md-12 " >
                            <form [formGroup]="airportRegFg"   autocomplete="off"  class=" row" >
                                
                               
                                
                                <mat-form-field class="col-md-6" appearance="outline">
                                  <mat-label>Name</mat-label>
                                  
                                  <input matInput type="text" formControlName="name"  name="name" autocomplete="off">
                                  <small *ngIf="airportRegFg.controls['name'].dirty && airportRegFg.controls['name'].invalid" class="warn">Please Enter name!</small>

                          
                                </mat-form-field>  
                                <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>City</mat-label>
                                    
                                    <input matInput type="text" formControlName="city"  name="city" autocomplete="off">
                                    <small *ngIf="airportRegFg.controls['city'].dirty && airportRegFg.controls['city'].invalid" class="warn">Please Enter City!</small>
  
                            
                                  </mat-form-field>  
                                 
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>Country</mat-label>

                                    <input matInput type="text" formControlName="country"  name="country" autocomplete="off">
                                    <small *ngIf="airportRegFg.controls['country'].dirty && airportRegFg.controls['country'].invalid" class="warn">Please Enter Country!</small>
  
                                   
                                  </mat-form-field>  
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>State</mat-label>
                                    <input matInput type="text" formControlName="state" name="state" autocomplete="off">
                                    <small *ngIf="airportRegFg.controls['state'].dirty && airportRegFg.controls['state'].invalid" class="warn">Please Enter State!</small>
                                  </mat-form-field>  
                                
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>Iata Code</mat-label>
                                    <input matInput type="text" formControlName="iataCode" [readonly]="action==='update'" name="iataCode" autocomplete="off">
                                    <small *ngIf="airportRegFg.controls['iataCode'].dirty && airportRegFg.controls['iataCode'].invalid" class="warn">Please Enter IataCode!</small>
  
                                  </mat-form-field>
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>Icao Code</mat-label>
                                    <input matInput type="text" formControlName="icaoCode" name="icaoCode" autocomplete="off">
                                    <small *ngIf="airportRegFg.controls['icaoCode'].dirty && airportRegFg.controls['icaoCode'].invalid" class="warn">Please Enter IcaoCode!</small>
  
                                  </mat-form-field>
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>Latitude</mat-label>
                                    <input matInput type="text" formControlName="latitude" name="latitude" autocomplete="off">
                                    <small *ngIf="airportRegFg.controls['latitude'].dirty && airportRegFg.controls['latitude'].invalid" class="warn">Please Enter Latitude!</small>
  
                                  </mat-form-field>
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>Longitude</mat-label>
                                    <input matInput type="text" formControlName="longitude" name="longitude" autocomplete="off">
                                    <small *ngIf="airportRegFg.controls['longitude'].dirty && airportRegFg.controls['longitude'].invalid" class="warn">Please Enter Longitude!</small>
  
                                  </mat-form-field>
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>Elevation</mat-label>
                                    <input matInput type="text" formControlName="elevation" name="elevation" autocomplete="off">
                                    <small *ngIf="airportRegFg.controls['elevation'].dirty && airportRegFg.controls['elevation'].invalid" class="warn">Please Enter Elevation!</small>
  
                                  </mat-form-field>
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>TimeZoneOffset</mat-label>
                                    <input matInput type="text" formControlName="timeZoneOffset" name="timeZoneOffset" autocomplete="off">
                                    <small *ngIf="airportRegFg.controls['timeZoneOffset'].dirty && airportRegFg.controls['timeZoneOffset'].invalid" class="warn">Please Enter TimeZoneOffset!</small>
  
                                  </mat-form-field>
                                  <mat-form-field class="col-md-6" appearance="outline">
                                    <mat-label>timeZone</mat-label>
                                    <input matInput type="text" formControlName="timeZone" name="timeZone" autocomplete="off">
                                    <small *ngIf="airportRegFg.controls['timeZone'].dirty && airportRegFg.controls['timeZone'].invalid" class="warn">Please Enter TimeZone!</small>
  
                                  </mat-form-field>
                                  <mat-form-field class="col-md-6" appearance="outline">

                                  <mat-select  name="status"   formControlName="status">
                                    <mat-option class="mat-primary" value="A">Active</mat-option>
                                    <mat-option class="mat-primary" value="I">Inactive</mat-option>
                                    <mat-option class="mat-primary" value="B">Black Listed</mat-option>

                                  </mat-select>
                                </mat-form-field>
                                

                                </form>
                    </div>
                    </div>
                    </div>                                      
              </div>
                <div class="modal-footer">
                  <div class="form-group form-inline ">
                    <label for="gstlabel" class="col-md-5 col-form-label control-label"> </label>
                  </div>   
                  <button *ngIf="action==='update'"  class="btn btn-outline-success c-width-100px shadow " (click)="AddAirport()" [disabled]="airportRegFg.invalid" >Update</button>

                  <button *ngIf="action==='new'"  class="btn btn-outline-success c-width-100px shadow " (click)="AddAirport()" [disabled]="airportRegFg.invalid" >Save</button>
                  <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                </div>
              </div>
              </div>
      </div>
  </div>